import React, { PropsWithChildren, useContext } from 'react';
import { useAsyncCallback, UseAsyncReturn } from 'react-async-hook';
import { connectApiAxios } from '../config/axios';
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { ForgotPasswordSubmitProps, SignUpProps } from "../types/auth-types";


type UserContextProps = {
  signUp: UseAsyncReturn<any, [SignUpProps]>;
  userDetails: UseAsyncReturn<any>;
  forgotPasswordSubmit: UseAsyncReturn<any, [ForgotPasswordSubmitProps]>;
};

const UserContext = React.createContext<UserContextProps>({} as any);

const UserContextProvider: React.FC<PropsWithChildren<any>> = ( props ) => {
  const { children } = props;
  const cookies = new Cookies();
  const navigate = useNavigate();
  const x_api_key = process.env['REACT_APP_X_API_KEY'] || '';

  const signUp = useAsyncCallback<any, [SignUpProps]>(async ( params: SignUpProps ) => {
    await connectApiAxios.post(`/api/users/${params.userId}/password`, {
      "token": params.token,
      "newPassword": params.password,
    });
  });


  const userDetails = useAsyncCallback<any>(async () => {
    const token = cookies.get('jwt_authorization')
    if(!token){
      navigate('/login');
    }
    else{
      const {data} = await connectApiAxios.get(`/api/users/me`,
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      );
      if(!data){
        navigate('/login');  
      }
      cookies.set('companyId', data?.customer?.company?.id);
      
    return data;
    }
  });

  const forgotPasswordSubmit = useAsyncCallback<any, [ForgotPasswordSubmitProps]>(async ( params: ForgotPasswordSubmitProps ) => {
    await connectApiAxios.post(`/api/users/${params.id}/password`,
      {
        "token": params.token,
        "newPassword": params.newPassword,
      },
      {
        headers: {
          'x-api-key': x_api_key
        }
      }
    );
  });


  return (
    <UserContext.Provider
      value={{
        signUp,
        userDetails,
        forgotPasswordSubmit,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);

export default UserContextProvider;
